export default __webpack_public_path__ + "d25adc819fdb3fb6602f7827aecf1f81.png";